import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";

import { retrieveItem, useStorageItem } from "@helpers/storage";
import { showToast } from "@helpers/toast";
//import { logoutRequest } from "../../redux";

// const BASE_URL = "http://localhost:5050/dev/graphql";
const BASE_URL = "https://api-mission60.vertace.org/";
// const BASE_URL = "https://dev.vertace.org/nokkam-dev/api";

const httpLink = createHttpLink({
  uri: BASE_URL,
});

const authLink = setContext(async (_, { headers }) => {
  const token = retrieveItem("token");

  return {
    headers: {
      ...headers,
      token: token ? token : "",
    },
  };
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore",
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  },
};

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: defaultOptions,
});

const logout = () => {
  localStorage.clear();
  location.replace("/login");
};

export async function QueryRequest(query, variables, dispatch) {
  try {
    let response = await client.query({
      query,
      variables,
    });
    let isUnauthorized =
      JSON.stringify(response).indexOf("Not authorized") > -1;
    if (isUnauthorized && dispatch) {
      showToast({ type: "error", message: "Not authorized" });
      // logout();
      //  dispatch(logoutRequest("invalid"));
      return null;
    }
    return response;
  } catch (e) {
    if (dispatch) {
      //  dispatch(logoutRequest("invalid"));
    }
    return { req_error: e };
  }
}
export async function MutateRequest(mutation, variables, dispatch) {
  let response = null;
  try {
    response = await client.mutate({
      mutation,
      variables,
    });
    let isUnauthorized =
      JSON.stringify(response).indexOf("Not authorized") > -1;
    if (isUnauthorized && dispatch) {
      showToast({ type: "error", message: "Not authorized" });
      logout();
      //  dispatch(logoutRequest("invalid"));
      return null;
    }
    return response;
  } catch (e) {
    if (dispatch) {
      //  dispatch(logoutRequest("invalid"));
    }
    return { req_error: e };
  }
}
